import { ProponentDPSQuestion } from '../interfaces/protheus/ProponentDPSQuestion';

export const convertProponentDPSProtheusToProponentDPS = (
  proponentDPS: any
): ProponentDPSQuestion => ({
  code: proponentDPS.ZY_COPEOP,
  description: proponentDPS.ZY_DESCRIC,
});
